import { render } from "./IconChevronRight.vue?vue&type=template&id=da18ba60"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da18ba60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da18ba60', __exports__)) {
    api.reload('da18ba60', __exports__)
  }
  
  module.hot.accept("./IconChevronRight.vue?vue&type=template&id=da18ba60", () => {
    api.rerender('da18ba60', render)
  })

}


export default __exports__